class FaqAccordion extends HTMLElement {
  constructor() {
    super();
    this.items = Array.from(this.querySelectorAll('.faq-accordion__item'));
    this.onTriggerClick = this.onTriggerClick.bind(this);
  }

  connectedCallback() {
    this.items.forEach((item) => {
      const trigger = item.querySelector('.faq-accordion__trigger');
      const panel = item.querySelector('.faq-accordion__panel');

      if (!trigger || !panel) return;

      if (trigger.getAttribute('aria-expanded') === 'true') {
        panel.hidden = false;
        panel.style.height = 'auto';
      } else {
        panel.hidden = true;
        panel.style.height = '0px';
      }

      trigger.addEventListener('click', this.onTriggerClick);
    });

    window.addEventListener('resize', () => this.syncOpenPanelHeights());
  }

  disconnectedCallback() {
    this.items.forEach((item) => {
      const trigger = item.querySelector('.faq-accordion__trigger');
      if (trigger) trigger.removeEventListener('click', this.onTriggerClick);
    });
  }

  onTriggerClick(event) {
    const trigger = event.currentTarget;
    const item = trigger.closest('.faq-accordion__item');
    const panel = item.querySelector('.faq-accordion__panel');
    const isOpen = trigger.getAttribute('aria-expanded') === 'true';

    if (isOpen) {
      this.closePanel(trigger, panel);
    } else {
      this.openPanel(trigger, panel);
    }
  }

  openPanel(trigger, panel) {
    trigger.setAttribute('aria-expanded', 'true');
    panel.hidden = false;

    const targetHeight = panel.scrollHeight;
    panel.style.height = '0px';

    requestAnimationFrame(() => {
      panel.style.height = `${targetHeight}px`;
    });

    const onEnd = (e) => {
      if (e.propertyName !== 'height') return;
      panel.style.height = 'auto';
      panel.removeEventListener('transitionend', onEnd);
    };
    panel.addEventListener('transitionend', onEnd);
  }

  closePanel(trigger, panel) {
    trigger.setAttribute('aria-expanded', 'false');

    const currentHeight = panel.scrollHeight;
    panel.style.height = `${currentHeight}px`;

    requestAnimationFrame(() => {
      panel.style.height = '0px';
    });

    const onEnd = (e) => {
      if (e.propertyName !== 'height') return;
      panel.hidden = true;
      panel.removeEventListener('transitionend', onEnd);
    };
    panel.addEventListener('transitionend', onEnd);
  }

  syncOpenPanelHeights() {
    this.items.forEach((item) => {
      const trigger = item.querySelector('.faq-accordion__trigger');
      const panel = item.querySelector('.faq-accordion__panel');
      if (trigger && panel && trigger.getAttribute('aria-expanded') === 'true' && !panel.hidden) {
        panel.style.height = 'auto';
      }
    });
  }
}

customElements.define('faq-accordion', FaqAccordion);